/**
 * Feature flags for web — mirror mobile/EAS production defaults.
 */
export function isSpeedDateEnabled() {
  const raw = import.meta?.env?.VITE_SPEEDDATE_ENABLED ?? process.env.VITE_SPEEDDATE_ENABLED;
  if (raw === undefined || raw === '') {
    const mode = import.meta?.env?.MODE || process.env.NODE_ENV;
    return mode !== 'production';
  }
  return raw === '1' || raw === 'true' || raw === 'yes';
}

export function getFeatureFlags() {
  return {
    speedDateEnabled: isSpeedDateEnabled(),
  };
}
